// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"ac350c5c","455":"d97c220c","977":"d52947aa"}[chunkId] + ".chunk.js";
};